import React from 'react';
import classnames from 'classnames';

import { useChatContext } from 'features/video-conference/state/chatContext';
import { useAnnotationContext } from 'features/video-conference/state/annotationContext';
import Chat from 'features/video-conference/components/Chat';
import Annotation from 'features/video-conference/components/Annotation';
import RemoteParticipantVideo from 'features/video-conference/components/RemoteParticipantVideo';
import ParticipantVideo from 'features/video-conference/components/ParticipantVideo';
import AttachVisibilityHandler from 'features/video-conference/components/AttachVisibilityHandler';
import Toolbar from 'features/video-conference/components/Toolbar';
import { useConference } from 'features/video-conference/state/conferenceContext';
import { isMobile } from 'features/video-conference/utils';
import useStyles from './styles';
import BackgroundSelectionDialog from 'features/video-conference/components/BackgroundSelectionDialog';

const Room = (): JSX.Element => {
  const { room, isBackgroundSelectionOpen } = useConference();
  const { isChatWindowOpen } = useChatContext();
  const { isAnnotationWindowOpen } = useAnnotationContext();

  const classes = useStyles({ isMobile });
  const isDrawerOpen =
    isChatWindowOpen || isAnnotationWindowOpen || isBackgroundSelectionOpen;

  if (!room) return <></>;

  const renderContent = () => {
    return (
      <div className={classes.room}>
        <Chat />
        <Annotation />
        <BackgroundSelectionDialog />
        <main
          className={classnames(classes.content, {
            [classes.contentShift]: isDrawerOpen,
          })}
        >
          <RemoteParticipantVideo />
          <ParticipantVideo />
          <AttachVisibilityHandler />
        </main>
        <Toolbar />
      </div>
    );
  };

  return renderContent();
};

export default Room;
